/* nh-reveal.js | owner: 2f MOTION | North Home revamp.
   Toggles CSS classes only: no click handlers, no text, no data attributes,
   no DOM nodes added. Only elements BELOW the fold at load get a hidden start
   state, and only once this script runs, so content never waits for JS.
   Reduced motion: does nothing. CSS: assets/nh-motion.css. */
(function () {
  'use strict';
  var w = window, d = document, root = d.documentElement;
  if (!('IntersectionObserver' in w) || !root.classList) return;
  root.classList.add('nh-js');
  if (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CARDS = '.spb__tile,.spf__card,.sp-feat__card,.spc__card,product-recommendations .resource-card';
  var REVEAL = '.nhc-rv,.spb__tag,.spf__h,.sp-feat__h2,.sp-faq__h2,.sp-cmp__h2,.sp-cmp__scroll,.sp-comp__h2,.spr-title,.spts,.spc__h1,' + CARDS;
  var IMGS = CARDS.split(',').join(' img,') + ' img';
  var all = function (s) { return Array.prototype.slice.call(d.querySelectorAll(s)); };
  var below = function (el) { return el.getBoundingClientRect().top > w.innerHeight; };

  function reveal(entries, io) {
    var vh = w.innerHeight, batch = [];
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      if (batch.indexOf(e.target) < 0) batch.push(e.target);
      /* cards clipped sideways in a phone swipe row enter with their row */
      Array.prototype.forEach.call(e.target.parentNode ? e.target.parentNode.children : [], function (s) {
        if (batch.indexOf(s) < 0 && s.classList.contains('nh-rv') && !s.classList.contains('nh-in')) {
          var r = s.getBoundingClientRect();
          if (r.top < vh && r.bottom > 0) batch.push(s);
        }
      });
    });
    batch.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    batch.forEach(function (el, i) {
      io.unobserve(el);
      if (i) el.classList.add('nh-d' + Math.min(i, 5));
      el.classList.add('nh-in');
    });
  }

  function seams(entries) {
    entries.forEach(function (e) {
      var r = e.boundingClientRect, h = e.rootBounds ? e.rootBounds.height : w.innerHeight;
      var edge = e.target.classList.contains('nh-seam--t') ? r.top : r.bottom;
      e.target.classList.toggle('nh-on', e.isIntersecting && edge >= 0 && edge <= h);
    });
  }

  function start() {
    /* read everything first, then write */
    var els = all(REVEAL).filter(below);
    var imgs = all(IMGS).filter(function (im) { return !im.complete && below(im); });
    var hero = d.querySelector('.sp-hero,.nhc-hero'), foot = d.querySelector('footer > .shopify-section');
    var heroWrap = hero && hero.closest('.shopify-section');

    var io = new IntersectionObserver(reveal, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('nh-rv'); io.observe(el); });

    imgs.forEach(function (im) {
      var done = function () { im.classList.add('nh-img-in'); };
      im.classList.add('nh-img');
      im.addEventListener('load', done, { once: true, passive: true });
      im.addEventListener('error', done, { once: true, passive: true });
      if (im.complete) done();
    });

    var steps = [], i;
    for (i = 0; i <= 20; i++) steps.push(i / 20);
    var so = new IntersectionObserver(seams, { threshold: steps });
    [[heroWrap, 'nh-seam--b'], [foot, 'nh-seam--t']].forEach(function (p) {
      if (!p[0]) return;
      p[0].classList.add('nh-seam', p[1]);
      so.observe(p[0]);
    });
  }

  /* once an entrance has played, drop its classes so later display changes
     (filters, swipe rows) never replay it */
  d.addEventListener('animationend', function (e) {
    var c = e.target.classList;
    if (e.animationName !== 'nh-rise' || !c || !c.contains('nh-in')) return;
    c.remove('nh-rv', 'nh-in', 'nh-d1', 'nh-d2', 'nh-d3', 'nh-d4', 'nh-d5');
  }, { passive: true });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
